




























































































import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { ResourceDataSource } from '@/business/resource/resource-data-source'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import RespondecoPagination from '@/main/respondeco-pagination.vue'
import RespondecoSearchResults from '@/shared/components/respondeco-search-results.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import RespondecoPager from '@/main/respondeco-pager.vue'
import HeroSearchField from '@/shared/components/hero-search-field.vue'
import DefaultHeader from '@/main/default-header.vue'
import { BaseComponent } from '@/shared/components/base-component'
import { Paginator } from '@/shared/models/data/paginator'
import { DataSourcePaginator } from '@/shared/models/data/data-source-paginator'
import { ResourceModule } from '@/business/resource/store/resource-module'
import RespondecoBackgroundImage from '@/shared/components/respondeco-background-image.vue'
import RespondecoImage from '@/shared/components/respondeco-image.vue'
import { DialogService } from '@/shared/dialog/dialog-service'
import { ResourceType } from '@/business/resource/interfaces/resource-type'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'
import { NotificationService } from '@/shared/services/notification-service'
import { imageUrl } from '@/shared/utils/images'
import { ExtendedBlob } from '@/shared/models/extended-blob'
import { Hooks } from '@/shared/interfaces/hooks'
import RespondecoDropArea from '@/shared/components/respondeco-drop-area.vue'
import RenameResourceDialog from '@/business/resource/components/rename-resource-dialog/rename-resource-dialog.vue'
import { RenameResourceDialogInput } from '@/business/resource/components/rename-resource-dialog/rename-resource-dialog-input'
import ResourceItem from '@/business/resource/components/resource-item.vue'
import ResourceToolbar from '@/business/resource/components/resource-toolbar.vue'
import { imageDialog } from '@/main/image-dialog'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoFileInput from '@/shared/components/respondeco-file-input.vue'
import RespondecoStepper from '@/shared/components/respondeco-stepper.vue'
import RespondecoStep from '@/shared/components/respondeco-step.vue'
import { Steppable } from '@/shared/interfaces/steppable'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import { TranslateService } from '@/shared/services/translate-service'
import { ResourceVariantViewModel } from '@/business/resource/interfaces/resource-variant-view-model'
import { RejectedFile } from '@/shared/models/rejected-file'
import RespondecoRejectedFilesAlert from '@/shared/components/respondeco-rejected-files-alert.vue'
import { activeUserIsPremium } from '@/shared/utils/user'

@Component({
  components: {
    RespondecoRejectedFilesAlert,
    RespondecoToolbarItem,
    RespondecoStep,
    RespondecoStepper,
    RespondecoFileInput,
    RespondecoToolbar,
    ResourceItem,
    ResourceToolbar,
    RespondecoDropArea,
    RespondecoIcon,
    RespondecoImage,
    RespondecoBackgroundImage,
    DefaultHeader,
    HeroSearchField,
    RespondecoPager,
    RespondecoLoadingIndicator,
    RespondecoSearchResults,
    RespondecoPagination,
  },
})
export default class ResourcesPage extends BaseComponent implements Hooks {
  public accept: string = 'image/gif,image/jpeg,image/png'
  public allowedFileTypes: RegExp[] = [/image.(gif|jpeg|png)/]
  public maxFileSize: number = 8 * 1024 * 1024
  public rejectedFiles: RejectedFile[] | null = null

  private dialogService = Injector.get(DialogService)
  private paginator!: Paginator<ResourceViewModel>
  private resourceModule = Injector.get(ResourceModule)

  private dataSource = Injector.get(ResourceDataSource)
  private notificationService = Injector.get(NotificationService)
  private translateService = Injector.get(TranslateService)

  private resource: ResourceViewModel | null = null
  private stepper: Steppable | null = null

  constructor() {
    super()

    this.paginator = new DataSourcePaginator<ResourceViewModel>(this.dataSource)
  }

  get isInitializing(): boolean {
    return this.paginator.isInitializing()
  }

  get isSearching(): boolean {
    return this.paginator.isSearching()
  }

  get items(): ResourceViewModel[] {
    return this.paginator.items
  }

  get noVariants(): boolean {
    return (this.selectedResource?.variants?.length ?? 0) < 1
  }

  get selectedResource(): ResourceViewModel | undefined {
    return this.items.find(item => item.id === this.resource?.id)
  }

  public destroyed(): void {
    this.dataSource.destroy()
  }

  // Lifecycle methods
  public mounted() {
    this.paginator.initialize()

    this.metaService.updateDocumentTitle('resources')

    this.stepper = (this.$refs.stepper as unknown) as Steppable

    if (activeUserIsPremium() === true) {
      this.accept = 'image/gif,image/jpeg,image/png,video/mp4'
      this.allowedFileTypes = [/image.(gif|jpeg|png)/, /video.mp4/]
      this.maxFileSize = 500 * 1024 * 1024
    }
  }

  public addVariant(resource: ResourceViewModel): void {
    imageDialog({
      file: resource.location,
    }).submitted(result => {
      this.dataSource.createVariant(result, resource)
    })
  }

  public back(): void {
    this.stepper?.back()
  }

  public createFiles(fileList: File[]): void {
    for (const file of fileList) {
      this.createResource(file)
    }
  }

  public createVariant(resource: ResourceViewModel): void {
    imageDialog({
      aspectRatio: undefined,
      file: imageUrl(resource.location),
      fileType: 'image/jpeg',
      viewMode: 1,
    }).submitted((file: ExtendedBlob) => {
      this.resourceModule
        .createResource({
          file,
          resource: {
            description: resource.description,
            name: resource.name,
            originalId: resource.id,
            type: resource.type,
          },
        })
        .then(
          this.notificationService.successHandler('resources.actions.add_variant.success'),
          this.notificationService.errorHandler('resources.actions.add_variant.failure')
        )
    })
  }

  public deleteResource(resource: ResourceViewModel): void {
    this.resourceModule
      .removeResource(resource.id)
      .then(
        this.notificationService.successHandler('resources.actions.delete.success', {
          onClick: () => {
            this.resourceModule
              .restoreResource({
                id: resource.id,
              })
              .then(this.notificationService.successHandler('resources.actions.restore.success'))
              .catch(this.notificationService.errorHandler('resources.actions.restore.failure'))
          },
          text: this.translateService.translate('resources.actions.delete.undo'),
        })
      )
      .catch(this.notificationService.errorHandler('resources.actions.delete.failure'))
  }

  public deleteVariant(resource: ResourceVariantViewModel): void {
    this.resourceModule
      .removeVariant({
        id: resource.id,
        originalId: this.selectedResource!.id,
      })
      .then(
        this.notificationService.successHandler('resources.actions.delete_variant.success', {
          onClick: () => {
            this.resourceModule
              .restoreResourceVariant({
                id: resource.id,
                originalId: this.selectedResource!.id,
              })
              .then(
                this.notificationService.successHandler('resources.actions.restore_variant.success')
              )
              .catch(
                this.notificationService.errorHandler('resources.actions.restore_variant.failure')
              )
          },
          text: this.translateService.translate('resources.actions.delete_variant.undo'),
        })
      )
      .catch(this.notificationService.errorHandler('resources.actions.delete_variant.failure'))
  }

  public fileChanged(fileList: FileList): void {
    // The length is 0 if the user cancels
    if (fileList.length > 0) {
      const file = fileList[0]

      this.createResource(file)
    }
  }

  public hideRejectedFiles(): void {
    this.rejectedFiles = null
  }

  public renameResource(resource: ResourceViewModel): void {
    this.dialogService.openDynamic<RenameResourceDialogInput, void>(RenameResourceDialog, {
      resource,
    })
  }

  public search(term?: string): void {
    this.paginator.query(term).update()
  }

  public showRejectedFiles(rejectedFiles: RejectedFile[]): void {
    this.rejectedFiles = rejectedFiles
  }

  public showVariants(resource: ResourceViewModel): void {
    if (resource.type === ResourceType.FILE) {
      this.resource = resource
      this.stepper?.select('variants')
    }
  }

  private createResource(file: File) {
    this.resourceModule
      .createResource({
        file,
        resource: {
          name: file.name,
          type: ResourceType.FILE,
        },
      })
      .catch(
        this.notificationService.errorHandler({
          400: 'resources.create.upload_failed.wrongFileType',
        })
      )
  }
}
